import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Contact.css';
import '../styles/ScrollAnimation.css';
import ScrollAnimation from '../utils/ScrollAnimation';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      await emailjs.send(
        'service_mj32lpj',
        'template_gpct5sj',
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
          reply_to: formData.email,
        },
        'H_axnzhVirlhCYuAt'
      );

      setSubmitStatus({
        type: 'success',
        message: 'Message sent. I will reply within one business day.',
      });
      setFormData({ name: '', email: '', message: '' });
    } catch {
      setSubmitStatus({
        type: 'error',
        message: 'Send failed. Email me directly or try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <ScrollAnimation className="fade-up">
          <div className="contact-hero">
            <h2 className="contact-title">
              Ready to start
              <br />
              <span className="gradient-text">your project?</span>
            </h2>
            <div className="divider-glow" />
            <p className="section-subtitle">
              New products, rewrites, or a specific bottleneck — brief context is enough.
            </p>
          </div>
        </ScrollAnimation>

        <div className="contact-layout">
          <ScrollAnimation className="fade-up">
            <aside className="contact-aside">
              <div className="contact-block">
                <span className="contact-label">Email</span>
                <a href="mailto:muqeetahmad25@gmail.com">muqeetahmad25@gmail.com</a>
              </div>
              <div className="contact-block">
                <span className="contact-label">Socials</span>
                <div className="contact-socials">
                  <a
                    href="https://github.com/MuqeetJanjua"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GitHub
                  </a>
                  <a
                    href="https://www.linkedin.com/in/muqeet-ahmad-ma/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>
                </div>
              </div>
              <a href="mailto:muqeetahmad25@gmail.com" className="btn btn--primary">
                Schedule a call
              </a>
            </aside>
          </ScrollAnimation>

          <ScrollAnimation className="fade-up" delay={80}>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="name"
                  required
                />
              </div>
              <div className="form-row">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                />
              </div>
              <div className="form-row">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  required
                />
              </div>
              {submitStatus.message && (
                <p className={`form-status form-status--${submitStatus.type}`}>
                  {submitStatus.message}
                </p>
              )}
              <button type="submit" className="btn btn--primary" disabled={isSubmitting}>
                {isSubmitting ? 'Sending…' : 'Send message'}
              </button>
            </form>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default Contact;
